"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utils_1 = require("../../core/utils");
var frontend_toolkit_1 = require("frontend-toolkit");
var HistoryInfo = function (_a) {
    var memberHistoryActivity = _a.memberHistoryActivity;
    var unformattedTransactedAtTime = new Date(memberHistoryActivity.transactedAt);
    var formatedTransactedAtTime = frontend_toolkit_1.DateService.dateToString(unformattedTransactedAtTime, frontend_toolkit_1.DateFormat.DATE_WITH_TIME_AND_TIMEZONE);
    var event = utils_1.capitalize(memberHistoryActivity.category) + " " + memberHistoryActivity.action;
    var description = memberHistoryActivity.description;
    var user = memberHistoryActivity.updaterName;
    return (React.createElement("div", { className: "Grid Grid--fit Grid--withGutter" },
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }, formatedTransactedAtTime)),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }, user)),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }, event)),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }, description))));
};
exports.default = HistoryInfo;
//# sourceMappingURL=history-info.js.map